import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { SPOTS_ENABLED } from '../utils/spotsApi';

const Footer = () => {

    return (
        <footer className="bg-light py-5 mt-5 border-top">
            <Container>
                <Row className="mb-4">
                    <Col md={3} className="mb-4 mb-md-0">
                        <h5 className="fw-bold mb-3">dein-Imker.de</h5>
                        <p className="text-muted small mb-3">
                            Finde Imkereien und Honigprodukte in deiner Nähe.
                        </p>
                    </Col>

                    <Col md={3} className="mb-4 mb-md-0">
                        <h6 className="fw-bold mb-3">Entdecken</h6>
                        <ul className="list-unstyled small">
                            <li className="mb-2"><Link to="/category/alle" className="text-decoration-none text-secondary">Imker finden</Link></li>
                            <li className="mb-2"><Link to="/map" className="text-decoration-none text-secondary">Karte</Link></li>
                            {SPOTS_ENABLED && (
                                <li className="mb-2"><Link to="/melden" className="text-decoration-none text-secondary">Verkaufsstelle melden</Link></li>
                            )}
                            <li className="mb-2"><Link to="/faq" className="text-decoration-none text-secondary">FAQ</Link></li>
                        </ul>
                    </Col>

                    <Col md={3} className="mb-4 mb-md-0">
                        <h6 className="fw-bold mb-3">Über uns</h6>
                        <ul className="list-unstyled small">
                            <li className="mb-2"><Link to="/about" className="text-decoration-none text-secondary">Über dein-Imker.de</Link></li>
                            <li className="mb-2"><Link to="/contact" className="text-decoration-none text-secondary">Kontakt</Link></li>
                        </ul>
                    </Col>

                    <Col md={3}>
                        <h6 className="fw-bold mb-3">Rechtliches</h6>
                        <ul className="list-unstyled small">
                            <li className="mb-2"><Link to="/imprint" className="text-decoration-none text-secondary">Impressum</Link></li>
                            <li className="mb-2"><Link to="/privacy" className="text-decoration-none text-secondary">Datenschutz</Link></li>
                        </ul>
                    </Col>
                </Row>

                <div className="border-top pt-4 d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <small className="text-muted mb-3 mb-md-0">
                        © {new Date().getFullYear()} dein-Imker.de — Ein Projekt von iBeekeeper
                    </small>

                    {/* <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faGlobe} className="text-secondary me-2" size="sm" />
                        <Form.Select
                            size="sm"
                            value={currentLanguage}
                            onChange={(e) => changeLanguage(e.target.value)}
                            className="border-0 bg-transparent"
                            style={{ width: 'auto' }}
                        >
                            <option value="de">Deutsch</option>
                            <option value="en">English</option>
                            <option value="fr">Français</option>
                        </Form.Select>
                    </div> */}
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
